module.exports = __webpack_public_path__ + "img/VentureWallet_Wide_Transparent.a24af149.png";